query GetCspCampaign($id: ID!) {
  cspCampaign(id: $id) {
    id
    insertedAt
    updatedAt
    expiredAt

    tcrCreatedAt
    tcrBilledAt
    tcrExpiredAt

    nextRenewalOrExpiredAt

    active

    tcr_status
    auto_renewal

    origin_id

    tcr_csp_id
    tcr_brand_id
    tcr_campaign_id

    vertical
    usecase
    sub_usecases

    tcrResellerId

    description

    embedded_link
    embedded_phone
    number_pool
    age_gated
    direct_lending
    subscriber_optin
    subscriber_optout
    subscriber_help
    affiliate_marketing
    terms_and_conditions

    samples

    privacy_policy_link
    terms_and_conditions_link
    embedded_link_sample

    message_flow
    help_message
    help_keywords
    optin_message
    optin_keywords
    optout_message
    optout_keywords

    shared

    mnos {
      mno
    }

    brand {
      id
      displayName
    }

    account {
      id
      name
    }
  }
}
